// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-recording__container {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 10px;
    align-items: center;
}

.video-preview__title {
    font-size: 2rem;
    font-weight: bold;
}

.video-recording-preview, .video-recording {
    aspect-ratio: 1;
    max-width: 300px;
    min-width: 300px;
    border-radius: 4px;
    border: 1px solid black;
}

.video-recording__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    max-width: 300px;
    background-color: #e6e6e6;
    aspect-ratio: 1;
    border-radius: 4px;
}

.video-recording__placeholder .video-recording__placeholder-icon {
    font-size: 5rem;
    color: rgba(0, 0, 0, 0.61);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/recording-dialog/video-recording-preview/VideoRecordingPreview.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B","sourcesContent":[".video-recording__container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.3rem;\r\n    padding: 10px;\r\n    align-items: center;\r\n}\r\n\r\n.video-preview__title {\r\n    font-size: 2rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.video-recording-preview, .video-recording {\r\n    aspect-ratio: 1;\r\n    max-width: 300px;\r\n    min-width: 300px;\r\n    border-radius: 4px;\r\n    border: 1px solid black;\r\n}\r\n\r\n.video-recording__placeholder {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 300px;\r\n    max-width: 300px;\r\n    background-color: #e6e6e6;\r\n    aspect-ratio: 1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.video-recording__placeholder .video-recording__placeholder-icon {\r\n    font-size: 5rem;\r\n    color: rgba(0, 0, 0, 0.61);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
